export * from './dropdown/search-filter.pipe';
export * from './dropdown/dropdown.module';
export * from './dropdown/dropdown.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/micro/Downloads/Proyectos/PagosContabilidadUriel/~/angular-2-dropdown-multiselect/index.js
// module id = ../../../../angular-2-dropdown-multiselect/index.js
// module chunks = 3